import React from "react";
import { Route } from "react-router-dom";
import HeaderContainer from "../../containers/shared/HeaderContainer";
import NavBarContainer from "../../containers/shared/NavBarContainer";
import Meta from "../shared/atoms/Meta";

const ProtectedLayout = ({ children }) => (
  <div>
    <Meta title="SaRa Marketplace - Admin" />
    {children}
  </div>
);

const index = ({ component: Component, ...rest }) => {
  return (
    <React.Fragment>
      <Route
        {...rest}
        render={(matchProps) => (
          <ProtectedLayout>
            <HeaderContainer />
            <div style={{ marginTop: "61px" }}>
              <NavBarContainer />
              <Component {...matchProps} />
            </div>
          </ProtectedLayout>
        )}
      />
    </React.Fragment>
  );
};
export default index;
